export * from './duplicata-receber-relatorios.component';